<!-- <div class="row" *ngFor="let entrevista of entrevistas">
  <div class="col-md-12">
    <div *ngIf="entrevista.audiovisual">
      <div *ngFor="let audiovisual of entrevista.audiovisual" [innerHTML]="audiovisual.rsc36"></div>
    </div>
    <video controls src="https://media.">
    </video>
  </div>
</div> -->
<section *ngIf="entrevistas && single">
  <div class="row" *ngFor="let entrevista of entrevistas">
<div class="col-md-3 offset-md-1 info">
  <!-- <h3 class="parent-header"><a href="entrevistas">Entrevistas</a></h3> -->
  <!-- <h1><span>{{entrevista.title}}</span></h1> -->
  <ul class="interview-meta">
    <!-- <li><strong><span i18n>Fecha:</span></strong>
      <ul><li>{{entrevista.date}}</li></ul>
    </li> -->
    <div [innerHTML]="entrevista.abstract" style="margin-bottom:50px;"></div>
    <li *ngIf="entrevista.informant"><strong><span i18n>Informantes:</span></strong>
      <ul>
        <li *ngFor="let i of entrevista.informant; let i = index; let odd = odd"><span *ngIf="odd">{{i.surname}}; {{i.name}}</span></li>
      </ul>
    </li>
  </ul>
  <!-- <ul class="filters">
    <li class="active"><a href="entrevistas">Entrevistas</a></li>
  </ul> -->
  <!-- <ul class="informant filters">
    <li *ngFor="let i of entrevista.informant">{{i.surname}}, {{i.name}}</li>
  </ul> -->
</div>
<div class="col-md-7" style="padding-left:40px;">
<section class="entrevista">
  <div class="row">
      <!-- <div *ngFor="let i of entrevista.image">
        <img [src]="'http://dedalo.anorgatarrak.eus'+i.src"/>
      </div> -->
      <!-- informant -->
      <!-- audiovisual -->
      <div style="width:100%;" *ngFor="let video of entrevista.audiovisual; let i = index;let odd = odd;">
        <div class="row" *ngIf="odd" style="margin-bottom:20px;">
          <video controls style="border:5px solid #fff;margin-bottom:20px;width:auto; margin:auto;background-image:url('https://backend.industriapaisaia.eus/wp-content/uploads/2019/01/industria-paisaia-poster.png');background-size:contain;background-repeat:no-repeat;background-position:center center;">
            <source [src]="this._MEDIAURL+video.video" type="video/mp4">
          </video>
        </div>
        <div class="row" *ngIf="video.rsc36 && odd">
          <!-- replace(/([\[](.*?)[\]])+/ig,'') -->
          <div class="transcrip" style="max-height:40vh;overflow-y:scroll;margin-top:20px;" [innerHTML]="video.rsc36 | hideMarkers">
          </div>
        </div>
      </div>
  </div>
</section>
</div>
</div>
</section>
<!-- grid -->
<section class="entrevista" *ngIf="entrevistas && !single">
 <div class="row item-container-wrapper" *ngFor="let entrevista of entrevistas" [routerLink]="entrevista.id" style="">
   <div class="col-md-3 offset-md-1">
     <div *ngIf="entrevista.image" class="thumbnail-image" [ngStyle]="{backgroundImage:'url('+this._MEDIAURL+entrevista.image[0].src+')'}"></div>
   </div>
   <div class="col-md-7">
     <div class="item-container" style="width:auto;">
        <h2 class="thumbtitle">{{entrevista.title}}</h2>
        <h3 class="thumbsubtitle"[innerHTML]="entrevista.abstract"></h3>
      </div>
  </div>
  <!-- <div class="col-md-4">
    <h3 [innerHTML]="entrevista.abstract"></h3>
  </div> -->
</div>
</section>
